import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/medal-green.svg'
import _imports_1 from '@/assets/images/dotted.svg'
import _imports_2 from '@/assets/images/menu-point.svg'


const _withScopeId = n => (_pushScopeId("data-v-e58eecea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "fs-75 px-lg-5 mt-lg-5 mt-4 break-word" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-6 d-flex text-green align-items-center justify-content-center" }
const _hoisted_5 = {
  key: 0,
  class: "fs-100"
}
const _hoisted_6 = {
  key: 1,
  class: "fs-100"
}
const _hoisted_7 = {
  key: 2,
  class: "fs-100"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "status1 bg-green text-white d-flex align-items-center justify-content-center" }, "交換"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-45" }, "pt")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "medal",
    class: "medal-green"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 bg-green d-flex justify-content-center align-items-center position-relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "dotted",
    class: "position-absolute position-dotted"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "menu",
    class: "menu-point"
  })
], -1))
const _hoisted_11 = { class: "d-flex justify-content-end border-bottom fw-bold text-green pb-4" }
const _hoisted_12 = { class: "btn-green text-white fw-bold me-4 w-max-content fs-7" }
const _hoisted_13 = {
  key: 0,
  class: "fs-22 point-text",
  style: {"padding-left":"20px"}
}
const _hoisted_14 = {
  key: 1,
  class: "fs-22 point-text"
}
const _hoisted_15 = {
  key: 2,
  class: "fs-22 point-text"
}

import ModalProduct from './ModalProduct'
import { ref } from 'vue'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pointCurrent = ref<string>('')

const changePointCurrent = (index: number) => {
  if (index === 0) pointCurrent.value = '500'
  if (index === 1) pointCurrent.value = '1000'
  if (index === 2) pointCurrent.value = '5000'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(translate)('SJ10messageUserTab1')), 1),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (item, index) => {
        return _createElementVNode("div", {
          key: item,
          class: "p-2 mb-1 mx-lg-5"
        }, [
          _createElementVNode("div", {
            class: "row bg-white menu-container fw-bold mb-3 cursor-pointer",
            "data-bs-target": '#productModal',
            "data-bs-toggle": 'modal',
            onClick: ($event: any) => (changePointCurrent(index))
          }, [
            _createElementVNode("div", _hoisted_4, [
              (index === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "500"))
                : _createCommentVNode("", true),
              (index === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "1,000"))
                : _createCommentVNode("", true),
              (index === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "5,000"))
                : _createCommentVNode("", true),
              _hoisted_8
            ]),
            _hoisted_9,
            _hoisted_10
          ], 8, _hoisted_3),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", _hoisted_12, _toDisplayString(_unref(translate)('SJ10usagePoints1')), 1),
            (index === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "500 pt"))
              : _createCommentVNode("", true),
            (index === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "1,000 pt"))
              : _createCommentVNode("", true),
            (index === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "5,000 pt"))
              : _createCommentVNode("", true)
          ])
        ])
      }), 64))
    ]),
    _createVNode(_unref(ModalProduct), { pointCurrent: pointCurrent.value }, null, 8, ["pointCurrent"])
  ], 64))
}
}

})